import React, { useState, useCallback } from 'react';
import Modal from '@components/Modal';
import * as styles from './DebugMenu.module.scss';

export default function DebugMenu({
  debugErrorCodes,
  showRackRates,
  testApiError
}) {
  const [isOpen, setIsOpen] = useState(false);

  const handleErrorButtonClick = useCallback(
    code => {
      setIsOpen(false);
      testApiError(code);
    },
    [testApiError]
  );

  return (
    <>
      <button
        className={styles.button}
        onClick={() => setIsOpen(true)}
      >
        Debug Menu
      </button>
      <Modal
        isOpen={isOpen}
        header="Calculator debug"
        setIsOpen={setIsOpen}
      >
        <Section title="Test API Errors">
          {showRackRates ? (
            <p>
              Cannot test API errors when rack rates are rendered. API errors
              can only be returned when fetching dynamic rates from the MORRIS
              API.
            </p>
          ) : (
            <>
              {debugErrorCodes?.length ? (
                <>
                  <p>
                    Click a button to simulate the API returning a specific
                    error code.
                  </p>
                  <div className={styles.errorButtons}>
                    {debugErrorCodes.map((code, index) => (
                      <ErrorButton
                        key={index}
                        code={code}
                        onClick={handleErrorButtonClick}
                      />
                    ))}
                  </div>
                </>
              ) : (
                <p>
                  No error codes found. You can configure errors from the
                  administration interface.
                </p>
              )}
            </>
          )}
        </Section>
      </Modal>
    </>
  );
}

function Section({ title, children }) {
  return (
    <div className={styles.section}>
      {title && <strong className={styles.subtitle}>{title}</strong>}
      {children}
    </div>
  );
}

function ErrorButton({ code, onClick }) {
  return (
    <button
      className="btn btn-primary"
      onClick={() => onClick(code)}
    >
      {code}
    </button>
  );
}
